export enum TaskStatus {
    Upcoming = 1,
    InProgress = 2,
    OnHold = 4,
    Completed = 6,
    Cancelled = 7
}